<template>
  <div class="terms-page">
    <div class="terms-header">
      <button class="back-btn" @click="$router.push('/')">&#8592; Back</button>
      <h1>{{ termsContent.title }}</h1>
      <h2>{{ termsContent.subtitle }}</h2>
    </div>

    <div class="terms-content">
      <section class="important-notice">
        <h3>IMPORTANT NOTICE</h3>
        <ol type="A">
          <li v-for="(notice, index) in termsContent.importantNotice" :key="index">
            {{ notice }}
          </li>
        </ol>
      </section>

      <section v-for="section in termsContent.sections" :key="section.title">
        <h3>{{ section.title }}</h3>
        <div v-html="section.html"></div>
      </section>
    </div>
  </div>
</template>

<script>
import { DEFAULT_TERMS_AND_CONDITIONS_KEY, getTermsAndConditionsContent } from '@/functions/termsAndConditions';
import {mapState} from 'vuex';

export default {
  name: 'TermsAndConditions',
  computed: {
    ...mapState(['brandConfig']),
    termsContent() {
      const brand = this.brandConfig && this.brandConfig.brand
        ? this.brandConfig.brand
        : DEFAULT_TERMS_AND_CONDITIONS_KEY;

      return getTermsAndConditionsContent(brand);
    }
  }
}
</script>

<style scoped>
.terms-page {
  padding: 1rem;
  color: #FFFFFF;
  max-height: 100vh;
  overflow-y: auto;
}

.terms-header {
  text-align: center;
  margin-bottom: 1.5rem;
}

.terms-header h1 {
  font-size: 1.2rem;
  margin: 0.5rem 0 0.25rem;
}

.terms-header h2 {
  font-size: 1rem;
  font-weight: normal;
  opacity: 0.85;
  margin: 0;
}

.back-btn {
  background: none;
  border: none;
  color: #FFFFFF;
  font-size: 0.9rem;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  float: left;
  opacity: 0.8;
}

.back-btn:hover {
  opacity: 1;
}

.terms-content {
  font-size: 0.8rem;
  line-height: 1.6;
  text-align: left;
}

.terms-content section {
  margin-bottom: 1.25rem;
}

.terms-content h3 {
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  color: #FFFFFF;
}

.terms-content :deep(p) {
  margin: 0.4rem 0;
  color: #FFFFFF;
  opacity: 0.9;
}

.terms-content :deep(ul),
.terms-content :deep(ol) {
  padding-left: 1.25rem;
  margin: 0.4rem 0;
}

.terms-content :deep(li) {
  margin-bottom: 0.3rem;
  opacity: 0.9;
}

.terms-content :deep(a) {
  color: #8ab4f8;
  text-decoration: underline;
}

.important-notice {
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  padding: 0.75rem;
  margin-bottom: 1.5rem;
  background: rgba(255, 255, 255, 0.05);
}

.important-notice h3 {
  color: #ff9800;
}
</style>
